import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TimeUnit } from '@mews/enums';
import { DateTime } from '@mews/framework';
import { dateTimeToLocalizedDate } from '@mews-commander/utils';
import { getDefaultTimeUnitRange } from '@mews-commander/legacy-entities/src/selectors/session/dateTime';
import { getRestrictionsModule } from './common';

const getFilters = createSelector(getRestrictionsModule, get('filters'));

export interface DateRange {
    startDateTime: DateTime;
    endDateTime: DateTime;
}

export const getDateRange = createSelector(
    getFilters,
    (state, { appClockService }) => getDefaultTimeUnitRange(state, { timeUnit: TimeUnit.Day, appClockService }),
    ({ dateRange }, defaultDateRange) => (dateRange ?? defaultDateRange) as DateRange
);

export const getLocalizedDefaultTimeUnitRange = createSelector(
    getDefaultTimeUnitRange,
    ({ startDateTime, endDateTime }) => ({
        startDate: dateTimeToLocalizedDate(startDateTime),
        endDate: dateTimeToLocalizedDate(endDateTime),
    })
);
